// src/utils/taskStatus.js
// The statuses a checklist item can have, in the order the status menu shows them (the Task tab and the
// task pop-up). "N/A" (Henry 10/06/2026, "some things don't apply"): an item that does not apply to this
// file. It is never owed: everywhere the app asks "is this item still open?" (the progress pills, the
// Active gate, Listing Prep, My Checklist, late alerts, the 7 AM email, automatic Work jobs, the LC hand
// off) N/A answers no, exactly like Completed. It is not Completed: it gets no completion stamp, it never
// checks a Work job, and it shows as a grey "N/A" pill. Pure, no imports, so every checklist module can
// lean on it. The server keeps the same rule in functions-api/listingPrepReminders.js (CLOSED_STATUSES).
export const NA_STATUS = "N/A";
export const TASK_STATUS_OPTIONS = ["Open", "In Progress", "Completed", NA_STATUS];

export const isNaTask = (t) => !!t && t.status === NA_STATUS;

// Finished for every "still owed?" question: Completed, or N/A.
export const isClosedStatus = (status) => status === "Completed" || status === NA_STATUS;

// The status pill's colors on the Task tab.
export const taskStatusColor = (status) => {
  if (status === "Open") return "bg-red-100 text-red-700";
  if (status === "In Progress") return "bg-blue-100 text-blue-700";
  if (status === "Completed") return "bg-green-100 text-green-700";
  if (status === NA_STATUS) return "bg-slate-200 text-slate-600";
  return "bg-gray-200 text-gray-700";
};
